import React from 'react'
import Batch from './Batch'
import { FirstStepEl } from '../Elements'
import { H4 } from '../../../../../../../Styles/typography'
import GroupRegistrationStore from '../Store/GroupRegistrationStore'

function FirstStep({
  withApproval,
  onSubmit,
  batches,
  pendingGroupEnrollment = false,
}) {
  const { next } = GroupRegistrationStore.useContainer()

  return (
    <FirstStepEl>
      <H4>Select the batch you would like to register in:</H4>
      <div className='batches'>
        {batches.map((batch, i) => (
          <Batch
            key={`existing-batch-${i}`}
            index={i}
            batch={batch}
            onSubmit={async (id) => {
              if (withApproval) next()
              else await onSubmit('', id)
            }}
            pendingGroupEnrollment={pendingGroupEnrollment}
          />
        ))}
      </div>
    </FirstStepEl>
  )
}

export default FirstStep
